import React, { useState } from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { LuType, LuPencilLine } from "react-icons/lu";
import FontPickerGrid from "../../canvas/editor_shortcuts/FontPickerGrid";
import { SUPPORTED_GOOGLE_FONTS } from "../../../../common/font_extractor.es6";

// "Inter, sans-serif" → "Inter": the picker stores a full CSS stack, the row
// only shows the family the user actually chose.
function fontLabel(value) {
  if (!value) return i18n.t("global_config.course_font_none");
  return value.split(",")[0].replace(/["']/g, "").trim();
}

// Course-wide font for every BasicText/RichText box. The list expands INSIDE
// this card instead of opening its own dialog — GlobalConfig is already a
// modal and the app forbids a popup over a popup.
export default function CourseFontSection({ value, onChange }) {
  const [picking, setPicking] = useState(false);

  return (
    <div className="gc-stack">
      <div className="gc-theme-row">
        <div className="gc-theme-status">
          <LuType aria-hidden="true" />
          <span className="gc-theme-status__text" style={value ? { fontFamily: value } : undefined}>
            {fontLabel(value)}
          </span>
        </div>
        <button
          type="button"
          className="gc-modal__btn gc-modal__btn--ghost gc-modal__btn--compact"
          onClick={() => setPicking(!picking)}
        >
          <LuPencilLine aria-hidden="true" />
          <span>{picking ? i18n.t("global_config.cancel") : i18n.t("ThemePalette.Select")}</span>
        </button>
      </div>

      {picking && (
        <div className="gc-font-picker">
          <FontPickerGrid
            value={value}
            googleFonts={SUPPORTED_GOOGLE_FONTS}
            onSelect={(next) => {
              onChange(next);
              setPicking(false);
            }}
          />
        </div>
      )}

      <p className="gc-hint">{i18n.t("global_config.course_font_note")}</p>
    </div>
  );
}

CourseFontSection.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
